import type { QueryKey } from "@tanstack/react-query";

const key = (base: string) => ({
  all: [base] as const,
  lists: (...args: QueryKey) => [base, "list", ...args] as const,
  detail: (...args: QueryKey) => [base, "detail", ...args] as const,
});

// ─────────────────────────────────────────────
// TRANSACTIONS (source of truth for kpis)
// ─────────────────────────────────────────────

export const igoldTransactionsKeys = key("igold-transactions");
export const icashTransactionsKeys = key("icash-transactions");

// ─────────────────────────────────────────────
// KPIS (invalidated together on any transaction mutation)
// ─────────────────────────────────────────────

export const kpisKeys = {
  all: ["kpis"] as const,
  users: (...args: QueryKey) => ["kpis", "users", ...args] as const,
  ateliers: (...args: QueryKey) => ["kpis", "ateliers", ...args] as const,
  employees: (...args: QueryKey) => ["kpis", "employees", ...args] as const,
};

// ─────────────────────────────────────────────
// ENTITIES
// ─────────────────────────────────────────────

export const usersKeys = {
  ...key("users"),
  profile: () => ["users", "profile"] as const,
};

export const ateliersKeys = key("ateliers");

export const employeesKeys = key("employees");

export const salariesKeys = key("salaries");
